import React, { useState } from "react"
import Button from '@mui/material/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import convert from "../../Helper/helper";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MoneyIcon from '@mui/icons-material/Money';
import { errorToast, successToast } from "../../components/toastmessage/toastmessage";
import PatinetInfo from "../../components/PatientInfo/patientInfo";
import { billInfo } from "./billHtml";
import { BillingInfo, fetchBillingById } from "./patientService";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import "./PatientRecieveFee.scss";

const initialState = {
    billType: "",
    amount: "",
    billDate: convert(new Date()),
    description: "",
}
const PatientRecieveFee = () => {
    const location = useLocation()
    const navigate = useNavigate();
    const [receiveFee, setReceiveFee] = useState(initialState)
    const getUserValue = JSON.parse(sessionStorage.getItem("loginDetails"))

    const handleReceiveFeeInputChange = (event) => {
        const { name, value } = event.target;
        setReceiveFee((prevState) => {
            return {
                ...prevState,
                [name]: value,
            };
        });
    }
    const handlePrint = (printvalue) => {
        const printDocument = () => {
            const mywindow = window.open("", "_blank", "");
            
            const css = "@page {size: Auto; margin: 2.5cm !important;}";
            const style = document.createElement("style");
            style.type = "text/css";
            style.media = "print";
            style.appendChild(document.createTextNode(css));
            
            mywindow.document.write(billInfo(printvalue && printvalue[0]));
            mywindow.document.getElementsByTagName("head")[0].append(style);
            mywindow.document.close();
            
            mywindow.focus();
            setTimeout(() => {
                mywindow.print();
                mywindow.close();
            }, 100);
        };
        printDocument();
    };

    const handalePaymentSubmit = async (event, payload, patientID, referralId, print, cb) => {
        event?.preventDefault();
        let finalPayload = {
            ...payload,
            patientID: patientID,
            referenceID: referralId,
            createdBy: getUserValue?.uniqueID,
            amount: Number(payload?.amount)
        }
        if (!print && cb === null) {
            try {
                let res = await BillingInfo(patientID, finalPayload);
                if (res?.status === 200) {
                    successToast(res?.data?.message || res?.data?.Message);
                }
            } catch (err) {
                errorToast(err?.response?.data?.error || err?.response?.data?.Message)
            }

        } else {
            try {
                let billRes = await BillingInfo(patientID, finalPayload);
                if (billRes?.status === 200) {
                    successToast(billRes?.data?.message || billRes?.data?.Message);
                    let billingInformation = await fetchBillingById(patientID, billRes?.data?.result?.uniqueId);

                    if (billingInformation?.data?.status) {
                        await cb(billingInformation?.data?.result)
                    } else {
                        errorToast("Failed to Fetch Billing Information")
                    }
                }

            } catch (err) {
                errorToast(err?.response?.data?.error || err?.response?.data?.Message)

            }
        }

    }
    const allowNumbersOnly = (e) => {
        let code = (e.which) ? e.which : e.keyCode;
        if (code > 31 && (code < 48 || code > 57)) {
            e.preventDefault();
        }
    }
    const handleGoBack = () => {
        navigate("/opd-list")
    }
    return (
        <div className="patient-recieve-fee">
            {location?.state === null ? null : <PatinetInfo rowData={location} />}
            <div className="mt-2 ml-4">
                <h4>Patient Receive Fee</h4>
                <div className="back-btn"
                    onClick={handleGoBack}
                >
                    <ArrowBackIcon className="arrow-color" />
                    <span
                        style={{ cursor: "pointer" }}
                        className="anchr-link header-text mt-3 mb-3"
                    >
                        {"Back"}
                    </span>
                </div>
            </div>

            <form className="needs-validation" novalidate>
                <div className="basic-info" >
                    <div className="row mt-3">
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Bill Date</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><CalendarMonthIcon /></div>
                                    </div>
                                    <input
                                        type="date"
                                        required
                                        className="form-control"
                                        id="lname" placeholder="Bill Date"
                                        name="billType"
                                        value={receiveFee?.billDate}
                                        onChange={handleReceiveFeeInputChange}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-md-6">
                            <label for="validationCustom03" className="control-label col-sm">Bill Type</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fa fa-gift" aria-hidden="true"></i></div>
                                    </div>
                                    <select class="form-control"
                                        selected={receiveFee?.billType}
                                        value={receiveFee?.billType}
                                        onChange={handleReceiveFeeInputChange}
                                        required
                                        name="billType"
                                    >
                                        <option value="Consultation Fees">Consultation Fees</option>
                                        <option value="Advance">Advance</option>
                                        <option value="Pharmacy">Pharmacy</option>
                                        <option value="Pharmacy">Pathology</option>
                                    </select>
                                    <div class="invalid-feedback">
                                        Please provide a valid Name.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Amount</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><MoneyIcon />
                                        </div>
                                    </div>
                                    <input
                                        id="exampleInputEmail1" aria-describedby="emailHelp"
                                        type="text"
                                        className="form-control"
                                        placeholder="Amount"
                                        name='amount'
                                        required
                                        value={receiveFee?.amount}
                                        onChange={handleReceiveFeeInputChange}
                                        min="0"
                                        onKeyDown={(e) => allowNumbersOnly(e)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="form-group col-md-6">
                            <label for="lname" className="control-label col-sm">Description</label>
                            <div class="col-auto">
                                <div class="input-group mb-2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fa fa-comment" aria-hidden="true"></i></div>
                                    </div>
                                    <textarea
                                        type="text"
                                        className="form-control"
                                        id="lname"
                                        placeholder="Description"
                                        name="description"
                                        value={receiveFee?.description}
                                        onChange={handleReceiveFeeInputChange}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-end mr-3 mb-3">
                    <Button variant="outlined" className="mr-2"
                        onClick={(event) => handalePaymentSubmit(event, receiveFee, location?.state?.patientID, location?.state?.referralId, false, null)}
                    >
                        Submit</Button>
                    <Button variant="outlined"
                        onClick={(event) => handalePaymentSubmit(event, receiveFee, location?.state?.patientID, location?.state?.referralId, true, handlePrint)}
                    >Submit & Print</Button>
                </div>
            </form>
        </div>
    )

}

export default PatientRecieveFee;